import { axiosInterceptors } from '~/utils/axiosInterceptor'

class AthlosApi {
	constructor(axios, baseUrl) {
		this.axios = axios
		this.baseUrl = baseUrl
	}

	getPointsByMatchSeries(matchSeriesId) {
		return this.axios.get(
			`${this.baseUrl}/standings/1.0/match-series/${matchSeriesId}/standings/points`
		)
	}

	getPointsByRoster(rosterId) {
		return this.axios.get(`${this.baseUrl}/standings/1.0/roster/${rosterId}/standings/points`)
	}
}

export default ({ $axios, $config }, inject) => {
	const athlosAxios = $axios.create({
		transformRequest: (data, headers) => {
			headers.Accept = 'application/json'
			if ($config.enableXStatusCode) {
				headers['X-Status-Code'] = true
			}
			return JSON.stringify(data)
		},
	})

	axiosInterceptors(athlosAxios)
	inject('athlosApi', new AthlosApi(athlosAxios, $config.apiBaseUrl))
}
